<template>
  <input
    ref="input"
    :value="value"
    :type="type"
    @input="checkInput"
    @paste="checkInput"
    @focus="$emit('focus')"
  >
</template>
<script>
  export default {
    props: {
      maxLength: {
        type: Number,
        default: 0,
      },
      type: {
        type: String,
        default: 'text',
      },
      value: {
        type: String,
        default: '',
      },
      restrictionRule: {
        type: RegExp,
        required: false,
      },
    },
    mounted() {
      if (this.maxLength) {
        this.$refs.input.setAttribute('maxlength', this.maxLength);
      }
    },
    methods: {
      checkInput(event) {
        const target = event.target;
        const { selectionStart, selectionEnd } = target;
        let value = target.value;

        if (this.maxLength && value.length > this.maxLength) {
          value = value.substring(0, this.maxLength);
        }

        if (this.restrictionRule) {
          value = value.replace(this.restrictionRule, '');
        }

        target.value = value;
        this.$emit('input', value);
        target.setSelectionRange(selectionStart, selectionEnd);
      },
      clear() {
        this.$refs.input.value = '';
      },
    },
  };
</script>
